export default "__VITE_PUBLIC_ASSET__f93e7157__"